/**
 * @generated SignedSource<<131b07c4ff7d2c3ddbd523f0bf5f09bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ConferenceCallProvider = "HANGOUTS_MEET" | "MS_TEAMS" | "SKYPE_FOR_BUSINESS" | "UNKNOWN" | "WEBEX" | "ZOOM";
import { FragmentRefs } from "relay-runtime";
export type OptionsMenu_note$data = {
  readonly event: {
    readonly conferenceCalls: ReadonlyArray<{
      readonly provider: ConferenceCallProvider;
    }>;
    readonly mainConferenceCall: {
      readonly provider: ConferenceCallProvider;
    } | null;
  } | null;
  readonly stream: {
    readonly id: string;
    readonly schedulingMeetingAssistantAutomationIsActive: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"OptionsMenu_AutoRecordMenu_refetchableAutoRecordReason">;
  };
  readonly " $fragmentType": "OptionsMenu_note";
};
export type OptionsMenu_note$key = {
  readonly " $data"?: OptionsMenu_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"OptionsMenu_note">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "provider",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OptionsMenu_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "schedulingMeetingAssistantAutomationIsActive",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "OptionsMenu_AutoRecordMenu_refetchableAutoRecordReason"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "event",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ConferenceCall",
          "kind": "LinkedField",
          "name": "mainConferenceCall",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ConferenceCall",
          "kind": "LinkedField",
          "name": "conferenceCalls",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "0f14971a2187cb85694ec31d09e41d49";

export default node;
